import { Injectable, Type } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable()
export class GrDialogService extends DialogService {
  override open(
    componentType: Type<unknown>,
    config: DynamicDialogConfig,
  ): DynamicDialogRef | null {
    const styleClass = ['gr-dialog', config.styleClass].filter(Boolean).join(' ');
    return super.open(componentType, { ...config, styleClass });
  }
}
